import angular from 'angular';

import SiteOperationalStatusRetailerListComponent from './site-operational-status-retailer-list-component';

export default angular
  .module('site-operational-status-retailer-list', [])
  .component('siteOperationalStatusRetailerList', new SiteOperationalStatusRetailerListComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/site-operational-status/components/site-operational-status-retailer-list/site-operational-status-retailer-list-module.js